var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ticket",
    d: "M0.5 15.771C0.5 16.6918 1.24583 17.4376 2.16667 17.4376L3.95703 17.4376C4.3037 17.4376 4.64214 17.2394 4.7513 16.9103C4.9713 16.2478 5.59667 15.771 6.33333 15.771C7.07 15.771 7.69537 16.2478 7.91537 16.9103C8.02453 17.2394 8.36297 17.4376 8.70963 17.4376L10.5 17.4376C11.4208 17.4376 12.1667 16.6918 12.1667 15.771L12.1667 2.43762C12.1667 1.51679 11.4208 0.770956 10.5 0.770956L8.70963 0.770956C8.36297 0.770956 8.02453 0.969133 7.91536 1.2983C7.69537 1.9608 7.07 2.43762 6.33333 2.43762C5.59667 2.43762 4.9713 1.9608 4.7513 1.2983C4.64213 0.969133 4.3037 0.770956 3.95703 0.770956L2.16667 0.770956C1.24583 0.770956 0.499999 1.51679 0.499999 2.43762L0.5 15.771ZM13.8333 15.0206L16.2747 4.65442C16.3164 4.47942 16.3333 4.31184 16.3333 4.13684C16.3333 3.12851 15.6585 2.21236 14.6585 1.96236L13.8333 1.75403L13.8333 15.0206Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ticket",
    fill: "#00273b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.1fc6602ba5cf7a7f38a2f30d1c5e23d4.svg";
export { ForwardRef as ReactComponent };